import createSvgIcon from '../../Utils/CreateSvgIcon';

export const Guide = createSvgIcon(
  <path
    d="M13 9H27V15H13V9ZM21 17H27V23H21L21 17ZM19 17H13V23H19L19 17ZM19 25H13H11V23V9V7H13H27H29V9V23V25H27H21H19ZM15 22V21H14V19H15V18H17V19H18V21H17V22H15ZM22 21H26V19H22V21Z"
    transform="translate(-8 -4)"
    fillRule="evenodd"
    clipRule="evenodd"
  />,
  'Guide',
);
